<div class="mt-4 pt-4">

  <div class="d-flex gap-8">
    <h2 class="title_4">{{ "PROCESSES.ACCOMMODATION.PENDING.TITLE" | translate }}</h2>
    <lf-icon height="24px" name="greenCheck" width="24px"></lf-icon>
  </div>
  <p
    class="subtitle_1">{{ "PROCESSES.ACCOMMODATION.PENDING.SUBTITLE" | translate:{value: booking.reduced_reservation_fees} }}</p>

  <div class="d-flex flex-column gap-24 text_4">
    <p class="mt-5">{{ "PROCESSES.ACCOMMODATION.PENDING.PARAGRAPH_1" | translate }}</p>
    <div *ngIf="agent">
      <app-need-help [contact]="agent" [showSubtitle]="false" [showTitle]="false" [type]="'paragraph'"
        class="pointer-ev-none"></app-need-help>
      <p>{{ "PROCESSES.ACCOMMODATION.PENDING.PARAGRAPH_2" | translate:{agent: agent.firstname} }}</p>
    </div>
    <p>{{ "PROCESSES.ACCOMMODATION.PENDING.PARAGRAPH_3" | translate }}</p>
    <p [innerHTML]="'PROCESSES.ACCOMMODATION.PENDING.PARAGRAPH_4' | translate"></p>

    <button (click)="goToProfile()" class="btn border-0 btn-gradient-blue w-fit-content align-items-center">
      {{ "PROCESSES.ACCOMMODATION.PENDING.GO_TO_PROFILE" | translate }}
      <lf-icon height="12px" name="rightChevron" width="12px"></lf-icon>
    </button>
  </div>

</div>
